import { render } from "./SwitchCard.vue?vue&type=template&id=f0107600"
import script from "./SwitchCard.vue?vue&type=script&lang=js"
export * from "./SwitchCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__